import * as React from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

export default function DeleteDialog({ open, handleClose, deleteCoach, setDeleteOperationOpen, deleteSchool, deletePrincipal }) {
  // Determine the entity type for the confirmation message
  const entityType = deleteSchool ? 'partnership site' : deletePrincipal ? 'Principal' : 'User';
  
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
      sx={{
        '& .MuiPaper-root': {
          borderRadius: 3,
          maxWidth: { xs: '90%', sm: '500px' },
          width: '100%',
        },
      }}
    >
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          {/* Delete Icon */}
          <Box
            sx={{
              width: { xs: 80, sm: 100 },
              height: { xs: 80, sm: 100 },
              borderRadius: '50%',
              bgcolor: 'error.lighter',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 3,
            }}
          >
            <DeleteOutlineIcon
              sx={{
                fontSize: { xs: 40, sm: 50 },
                color: 'error.main',
              }}
            />
          </Box>

          {/* Title */}
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              color: 'text.primary',
              mb: 2,
              fontSize: { xs: '1.5rem', sm: '1.75rem' },
            }}
          >
            Are you sure?
          </Typography>

          {/* Description */}
          <Typography
            variant="body1"
            sx={{
              color: 'text.secondary',
              mb: 4,
              maxWidth: '400px',
              lineHeight: 1.6,
              fontSize: { xs: '0.95rem', sm: '1rem' },
            }}
          >
            Are you sure to delete this {entityType}? This action cannot be undone.
          </Typography>

          {/* Action Buttons */}
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              width: '100%',
              maxWidth: '400px',
              justifyContent: 'center',
            }}
          >
            <Button
              onClick={handleClose}
              variant="outlined"
              color="main"
              sx={{
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                px: 3,
                py: 1,
                flex: 1,
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                deleteCoach();
                setDeleteOperationOpen(true);
                handleClose();
              }}
              variant="contained"
              color="error"
              sx={{
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                px: 3,
                py: 1,
                flex: 1,
              }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
